import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { EntityTypeEnum } from '../../../models/enums/entity-type.enum';
import { FavoriteModel } from '../../../models/favorite.model';
import { AlertService } from '../../../services/alert.service';
import { FavoritesResource } from '../../../services/resources/favorites.resource';

@Component({
    selector: 'sl-favorites-list',
    templateUrl: './favorites-list.component.html',
    styleUrls: ['./favorites-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FavoritesListComponent implements OnInit {
    @Input() type?: EntityTypeEnum;
    @Input() title = 'Dashboard.Favorites';

    favoritesList: FavoriteModel[] = [];
    displayedColumns: string[] = ['label', 'action'];

    private readonly router = inject(Router);
    private readonly favoritesResource = inject(FavoritesResource);
    private readonly alertService = inject(AlertService);

    ngOnInit(): void {
        if (!!this.type) {
            this.favoritesResource.getByType(this.type).subscribe(r => (this.favoritesList = r.value));
        } else {
            this.displayedColumns = ['tableName', ...this.displayedColumns];
            this.favoritesResource.getAll().subscribe(r => (this.favoritesList = r.value));
        }
    }

    goToView(item: FavoriteModel): void {
        const path = this.getBaseRoute(item.tableName);
        this.router.navigate([path, item.recordId]);
    }

    remove(event: MouseEvent, item: FavoriteModel): void {
        event.stopPropagation();
        this.alertService.showConfirm('General.AreYouSureRemove', undefined, () => {
            this.favoritesResource.remove(item).subscribe(() => {
                const idx = this.favoritesList.findIndex(i => i.tableName === item.tableName && i.recordId === item.recordId);

                this.favoritesList.splice(idx, 1);
                this.updateList();
            });
        });
    }

    private getBaseRoute(type: EntityTypeEnum): string {
        switch (type) {
            case EntityTypeEnum.Shareholder:
                return 'shareholders';
            case EntityTypeEnum.Trader:
                return 'traders';
            case EntityTypeEnum.Transaction:
                return 'transactions';
            case EntityTypeEnum.Report:
                return 'reports';
            case EntityTypeEnum.User:
                return 'settings/users';
        }
    }

    private updateList(): void {
        this.favoritesList = [...this.favoritesList]; // Required to trigger the view change.
    }
}
